import React from 'react';

import {
  Box,
  BoxProps,
  LinearProgress,
  Paper,
  PaperProps,
  useTheme,
} from '@mui/material';

interface Props extends PaperProps {
  loading?: boolean;
  childrenProps?: BoxProps;
}

export const PaperCardTemplate: React.FC<Props> = ({
  loading,
  sx,
  children,
  childrenProps,
  ...props
}) => {
  const { palette } = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{
        boxSizing: 'border-box',
        background: '#FFFFFF',
        border: '1px solid',
        borderColor: palette.primary.main,
        boxShadow:
          '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
        borderRadius: '10px',
        overflow: 'hidden',
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          height: 6,
        }}
      >
        {loading && <LinearProgress />}
      </Box>

      <Box px={4} py={2} {...childrenProps}>
        {children}
      </Box>

      <Box
        sx={{
          height: 6,
        }}
      />
    </Paper>
  );
};
